declare global {
	interface Window {
		__dataFetcherForSuspense__?: Record<string, SuspenseableDataFetcher>;
	}
}

export type SuspenseableDataFetcher = {
	getName: () => string;
	isTimeout: () => boolean;
	getError: () => Error | null;
	isPending: () => boolean;
	read: () => any;
	getPromise: () => Promise<any>;
};

export function getDataFetcherForSuspense(
	dataFetcherName: string | undefined | null,
	isSSRStreaming = true,
): SuspenseableDataFetcher | null {
	if (!isSSRStreaming || !dataFetcherName) {
		return null;
	}
	return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
